import axios from "axios";
import { Globals } from "../global/Globals";
import CryptoUtils from "../util/cryptoUtils";
import { deleteCookie, getCookie } from "../util/util";

const axiosInstance = axios.create({
   baseURL: '/api', // or full URLRL
});


axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = CryptoUtils.getFromCookie(Globals.JWT_TOKEN_NAME);//CryptoUtils.getFromLocalStorage(Globals.JWT_TOKEN_NAME)||window.jwtAccessToken ||
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
      config.headers['Accept-Language'] = localStorage.getItem('lang')|| 'en';
    }
    else{
       config.headers['Accept-Language'] = localStorage.getItem('lang')|| 'en';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if(!error.response && window.location.pathname !== "/"){
      document.body.classList.add('hide-loader');
      localStorage.clear();
          deleteCookie(Globals.JWT_TOKEN_NAME);
          window.location.href = '/';
          document.body.style.overflow = "auto";
    }
    if(error.response.status === 401 && error.response.statusText === "Unauthorized" && window.location.pathname !== "/"){
      document.body.classList.add('hide-loader');
      localStorage.clear();
          deleteCookie(Globals.JWT_TOKEN_NAME);
          window.location.href = '/';
          document.body.style.overflow = "auto";
    }
    if(error.response.status === 401 && window.location.pathname !== "/"){
      document.body.classList.add('hide-loader');
      localStorage.clear();
          deleteCookie(Globals.JWT_TOKEN_NAME);
          window.location.href = '/';
          document.body.style.overflow = "auto";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;